<template>
    <vue-cal :selected-date="fecha_inicial"
             :time-from="7 * 60"
             :time-to="19 * 60"
             :disable-views="['years', 'year', 'month']"
             :twelveHour="twelveHour"
             timeFormat="h:mm{am}"
             :timeCellHeight="calculatedCellHeight"
             :min-event-width="minWidth"
             :hide-weekdays="[1, 2, 3, 6, 7]"
             locale="es"
             :events="events">
    </vue-cal>
</template>

<script>
    import VueCal from 'vue-cal'
    import 'vue-cal/dist/i18n/es.js'
    import 'vue-cal/dist/vuecal.css'
    export default {
        name: "cta-calendar",
        components: {
            VueCal
        },
        data: () => ({
            twelveHour: true,
            minWidth: 0,
            pixelsPerMinute: 10 // Puedes ajustar este valor
        }),
        props: ["events", "fecha_inicial"],
        computed: {
            calculatedCellHeight() {
                // Aquí calculas la altura de la celda basándote en la duración de un evento.
                // Como vue-cal necesita una altura fija, tomamos la duración de la celda de tiempo (ej. 30 minutos).
                // Vue-cal por defecto trabaja con celdas de 30 minutos.
                const cellDurationInMinutes = 30; 
                return cellDurationInMinutes * this.pixelsPerMinute;
            }
        }
    }
</script>

<style>
    /* Estilos para el texto y la hora de los eventos */
    .vuecal__event-title { font-weight: bold; font-size: 13px; }
    .vuecal__event-time { font-size: 12px; }

    /* Estilos de la barra de título y el menú */
    .vuecal__title-bar { font-size: 18px; background-color: #e4f5ef; }
    .vuecal__menu { font-size: 16px; color: white; background-color: var(--theme-color); }

    /* Estilos para que los eventos se adapten a su contenido */
    .vuecal__event { 
        font-size: 12px;
        min-height: 20px; /* Altura mínima para eventos pequeños */
        overflow: hidden;
        white-space: normal;
        display: flex;
        justify-content: center; /* Centrado horizontal */
        align-items: center; /* Centrado vertical */
        flex-direction: column; /* Apila el título y la hora */
        text-align: center; /* Centra el texto */
    }
    
    .vuecal__no-event { display: none; }

    /* Estilos para los diferentes tipos de eventos */
    .vuecal__event.taller { background-color: rgba(253, 156, 66, 0.85); border: 1px solid rgb(233, 136, 46); color: #fff; }
    .vuecal__event.inaguracion { background-color: rgba(164, 230, 210, 0.9); border: 1px solid rgb(144, 210, 190); }
    .vuecal__event.magistral { background-color: rgba(255, 102, 102, 0.85); border: 1px solid rgb(235, 82, 82); color: #fff; }
    .vuecal__event.ponencias { background-color: rgba(255, 58, 143, 0.7); border: 1px solid rgb(235, 38, 123); color: #fff; }
    .vuecal__event.panel { background-color: rgba(100, 200, 255, 0.8); border: 1px solid rgb(80, 180, 235); color: #fff; }
    .vuecal__event.clausura { background-color: rgba(255, 200, 90, 0.75); border: 1px solid #ffc356; }
    .vuecal__event.lunch {
        background: repeating-linear-gradient(45deg, transparent, transparent 10px, #f2f2f2 10px, #f2f2f2 20px);
        color: #999;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .vuecal__event.lunch .vuecal__event-time { display: none; align-items: center; }
</style>
